import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { ButtonMenuItem, Divider } from './MenuItem';
import * as Utils from '../../../../_common/platform/ts/Utilities';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

import { IGlob } from '../../ts/Glob';

export interface IActionButton {
    key: string;
    title: string;
    icon: string;
    isActive?: boolean;
}

export default class ItemActionsSelector extends React.Component<
    {
        className?: string;
        buttons: IActionButton[];

        height?: number;
        width?: number;

        onActionClick(key: string);
        onShow?();
        onClose?();

        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    handleActionsMenuShow = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.props.onShow != null) {
            this.props.onShow();
        }

        const offset = $(e.target).offset();

        this.props.glob.DialogActions.createPopup<IActionsSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            buttons: this.props.buttons,
            height: this.props.height,
            width: this.props.width,

            onActionClick: this.props.onActionClick,
            onClose: this.props.onClose,

            component: ActionsSelectPopup
        });
    };

    render() {
        return (
            <div className={this.props.className || 'actions-button'}>
                <span className="glyphicon glyphicon-cog" title={'Actions'} onClick={this.handleActionsMenuShow} />
            </div>
        );
    }
}

interface IActionsSelectPopupState {
    height: number;
    width: number;
}

export interface IActionsSelectPopupOptions extends IPopupOptions {
    buttons: IActionButton[];
    height: number;
    width: number;

    onActionClick(key: string): void;
    onClose(): void;
}

export class ActionsSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IActionsSelectPopupOptions;

        close(): void;
    },
    IActionsSelectPopupState
> {
    private references: {
        popoverContent?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        const width = this.props.options.width != null ? this.props.options.width : 200;
        const height =
            this.props.options.height != null ? this.props.options.height : 40 + this.props.options.buttons.length * 50;

        this.state = {
            height: height,
            width: width
        };
    }

    componentDidMount() {
        const dialog = this.references.popoverContent;

        $(dialog).contextmenu(false);

        this.setState({
            height: dialog.clientHeight,
            width: dialog.clientWidth
        });
    }

    handleContainerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    handleClose = (e) => {
        e.stopPropagation();
        e.preventDefault();

        this.props.close();

        if (this.props.options.onClose != null) {
            this.props.options.onClose();
        }
    };

    getOnButtonClickHandler(key: string) {
        return (e) => {
            this.handleClose(e);

            if (this.props.options.onActionClick != null) {
                this.props.options.onActionClick(key);
            }
        };
    }

    render() {
        const options = this.props.options;

        const popoverStyle = Utils.getPopoverStyle(options, {
            width: this.state.width,
            height: this.state.height
        });

        const style = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            width: this.state.width,
            zIndex: this.props.zIndex
        };

        return (
            <div className="item-actions-popup-dialog">
                <div
                    className={'popover item-actions-popup-dialog-popover ' + popoverStyle.side}
                    style={style}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                    onClick={this.handleContainerClick}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <div className="popover-body">
                        {_.map(options.buttons, (button, index) => {
                            if (button == null) {
                                return <Divider key={'divider_' + index} />;
                            } else {
                                return (
                                    <ButtonMenuItem
                                        key={button.key}
                                        title={button.title}
                                        icon={button.icon}
                                        isActive={button.isActive}
                                        onClick={this.getOnButtonClickHandler(button.key)}
                                    />
                                );
                            }
                        })}
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-default" onClick={this.handleClose}>
                            {'Close'}
                        </button>
                    </div>
                </div>

                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}
